var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13089 10.443L14.8272 10.443L8.92147 16.3488C8.5445 16.7257 8.5445 17.354 8.92147 17.731C9.29843 18.1079 9.80105 18.1079 10.178 17.731L17.7173 10.1917C18.0942 9.81472 18.0942 9.18645 17.7173 8.80948L10.178 1.27022C9.80105 0.893254 9.17277 0.893254 8.79581 1.27022C8.41885 1.64718 8.41885 2.1498 8.79581 2.52676L14.7016 8.55817L1.00523 8.55818C0.502616 8.55818 -7.93671e-07 8.93514 -7.38745e-07 9.56341C0.251308 10.066 0.62827 10.5686 1.13089 10.443Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedRightArrow);
export default __webpack_public_path__ + "static/media/red-right-arrow.f8dff7197d7ea5db804f354f01f4fd75.svg";
export { ForwardRef as ReactComponent };